import React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

function UnsetLettersDialog(props) {

    const { onClose, open } = props;

    function handleClose() {
        onClose(false);
    }

    function handleOk() {
        onClose(true);
    }

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
            <DialogTitle id="simple-dialog-title">Not all letters set!</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    If you proceed, your unset letters will be set to 'no synesthetic colour'.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleOk} color="primary" autoFocus>
                    OK
                </Button>
                </DialogActions>
        </Dialog>
    );
}

export default UnsetLettersDialog;